const BASE_URL = 'alumni_v2/reviews';

const SET_REVIEWS_INIT = `${BASE_URL}/SET_REVIEWS`;
const SET_REVIEWS_ERROR = `${BASE_URL}/SET_REVIEWS_ERROR`;
const SET_REVIEWS_COMPLETE = `${BASE_URL}/SET_REVIEWS_COMPLETE`;
const SET_QUESTIONS_INIT = `${BASE_URL}/SET_QUESTIONS`;
const SET_QUESTIONS_ERROR = `${BASE_URL}/SET_QUESTIONS_ERROR`;
const SET_QUESTIONS_COMPLETE = `${BASE_URL}/SET_QUESTIONS_COMPLETE`;
const OPEN_QNA_MODAL = `${BASE_URL}/OPEN_QNA_MODAL`;
const CLOSE_QNA_MODAL = `${BASE_URL}/CLOSE_QNA_MODAL`;
const SET_VERIFY_COMPLETE = `${BASE_URL}/SET_VERIFY_COMPLETE`;
const SET_USER_DETAILS = `${BASE_URL}/SET_USER_DETAILS`;
const SET_REQUEST_PARAMS = `${BASE_URL}/SET_REQUEST_PARAMS`;
const TOGGLE_SUCCESS_MODAL = `${BASE_URL}/TOGGLE_SUCCESS_MODAL`;
const TOGGLE_MISSING_DETAILS = `${BASE_URL}/TOGGLE_MISSING_DETAILS`;
const TOGGLE_SHARE_STATE = `${BASE_URL}/TOGGLE_SHARE_STATE`;
const SET_INITIAL_RESOURCES_INIT = `${BASE_URL}/SET_INITIAL_RESOURCES_INIT`;
// eslint-disable-next-line max-len
const SET_INITIAL_RESOURCES_COMPLETE = `${BASE_URL}/SET_INITIAL_RESOURCES_COMPLETE`;
const SET_INITIAL_RESOURCES_ERROR = `${BASE_URL}/SET_INITIAL_RESOURCES_ERROR`;
const FC_MODAL_OPEN = `${BASE_URL}/FC_MODAL_OPEN`;
const FC_MODAL_CLOSE = `${BASE_URL}/FC_MODAL_CLOSE`;
const SET_FC_REGISTERED_ALREADY = `${BASE_URL}/SET_FC_REGISTERED_ALREADY`;
const SET_FC_REGISTERED = `${BASE_URL}/SET_FC_REGISTERED`;
const SET_FC_REGISTERING = `${BASE_URL}/SET_FC_REGISTERING`;
const SET_UPCOMING_LIVE_CLASS = `${BASE_URL}/SET_UPCOMING_LIVE_CLASS`;
const SET_UPCOMING_LIVE_CLASS_ERROR = `
  ${BASE_URL}/SET_UPCOMING_LIVE_CLASS_ERROR`;
const SET_PERSONALISATION_MODAL_OPEN = `
  ${BASE_URL}/SET_PERSONALISATION_MODAL_OPEN`;
const SET_PROFILE_SIDEBAR = `
  ${BASE_URL}/SET_PROFILE_SIDEBAR`;
const SET_SIGNUP_SIDEBAR = `
  ${BASE_URL}/SET_SIGNUP_SIDEBAR`;

export default {
  SET_REVIEWS_INIT,
  SET_REVIEWS_ERROR,
  SET_REVIEWS_COMPLETE,
  SET_QUESTIONS_INIT,
  SET_QUESTIONS_ERROR,
  SET_QUESTIONS_COMPLETE,
  OPEN_QNA_MODAL,
  CLOSE_QNA_MODAL,
  SET_VERIFY_COMPLETE,
  SET_USER_DETAILS,
  SET_REQUEST_PARAMS,
  TOGGLE_SUCCESS_MODAL,
  TOGGLE_MISSING_DETAILS,
  TOGGLE_SHARE_STATE,
  SET_INITIAL_RESOURCES_INIT,
  SET_INITIAL_RESOURCES_COMPLETE,
  SET_INITIAL_RESOURCES_ERROR,
  FC_MODAL_OPEN,
  FC_MODAL_CLOSE,
  SET_FC_REGISTERED,
  SET_FC_REGISTERING,
  SET_UPCOMING_LIVE_CLASS,
  SET_UPCOMING_LIVE_CLASS_ERROR,
  SET_FC_REGISTERED_ALREADY,
  SET_PERSONALISATION_MODAL_OPEN,
  SET_PROFILE_SIDEBAR,
  SET_SIGNUP_SIDEBAR,
};
